import { ModulesMap } from '@/config/data/modulesMaps'

import DataTransferModule from '@/services/dataTransferModule'

import FieldsTagsApi from '@/services/apiServiceModules/fieldsTagsApi.js'
const fieldsTagsApi = new FieldsTagsApi()

export default class FieldsTagsDt extends DataTransferModule {
	constructor() {
		super(ModulesMap.FIELDS_TAGS, fieldsTagsApi, {
			useCache: true,
		})
	}
}
